/*
 * @Author: 刘彭涛 157511383@qq.com
 * @Date: 2022-04-09 14:05:47
 * @LastEditors: 刘彭涛 157511383@qq.com
 * @LastEditTime: 2022-08-27 15:14:10
 * @FilePath: \zero-c-cloud\src\server\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import axios from '../utils/aioxs'
import { domainid } from '@/utils/utils'

const checkin = loginForm => {
  // 登录
  return axios({
    method: 'post',
    url: '/signon/api/runtime/login/checkin',
    data: loginForm,
  })
}
const login = data => {
  // 登录
  return axios({
    method: 'post',
    url: '/auth/login',
    data: data,
  })
}
const changeCheckcodeImg = () => {
  // 更改验证图案
  return axios({
    method: 'post',
    url: '/signon/api/runtime/login/changeCheckcodeImg',
  })
}

const changesignin = loginForm => {
  // 选择域
  return axios({
    method: 'post',
    url: '/signon/api/runtime/login/signin',
    data: loginForm,
  })
}
const getPermissions = () => {
  // 权限列表
  return axios({
    method: 'post',
    url: `/auth/permissions`,
  })
}
const logout = () => {
  // 退出
  return axios({
    method: 'post',
    url: `/auth/logout`,
  })
}
// 获取用户清单
const getDomainUsers = (role = '站点用户') => {
  return axios({
    method: 'get',
    url: `/auth/roles/${role}/users/list`,
  })
}
const convert = params => {
  return axios({
    method: 'get',
    url: `/v3/assistant/coordinate/convert`,
    requestBaseUrl: 'restapi',
    params: Object.assign(
      {
        key: '195b56469ebfee5f34ab067663052d78',
        coordsys: 'baidu',
      },
      params,
    ),
  })
}
const weather = params => {
  // 天气
  return axios({
    method: 'get',
    url: `/v3/weather/weatherInfo`,
    requestBaseUrl: 'restapi',
    params: Object.assign(
      {
        key: '195b56469ebfee5f34ab067663052d78',
        extensions: 'base',
      },
      params,
    ),
  })
}
const CityinverseAnalysis = params => {
  //传入经纬度
  // location 经度在前，纬度在后，经纬度间以“,”分割
  // 地址逆解析
  return axios({
    method: 'get',
    url: `/v3/geocode/regeo`,
    requestBaseUrl: 'restapi',
    params: Object.assign(
      {
        key: '195b56469ebfee5f34ab067663052d78',
      },
      params,
    ),
  })
}
//视频监控
const videoList = (stationId, type = 'device') => {
  return axios({
    method: 'get',
    url: `/operation/${domainid()}/${stationId}/video/list`,
    params: {
      type,
    },
  })
}

//视频监控地址
const videoUrl = (stationId, device_id) => {
  return axios({
    method: 'get',
    url: `/operation/${domainid()}/${stationId}/video/device/url`,
    params: {
      device_id,
    },
  })
}
//监控配置
const MonitoringControl = (stationId, params) => {
  return axios({
    method: 'get',
    url: `/operation/${domainid()}/${stationId}/video/device/ptz`,
    params: Object.assign(
      {
        action: 'continuous_move',
      },
      params,
    ),
  })
}
//图片上传
export const pictureupload = datas => {
  return axios({
    method: 'post',
    url: `/oss/upload/picture`,
    data: datas,
  })
}
// 获取天气
const getWeather = data => {
  return axios({
    method: 'post',
    url: '/datapool/url_query',
    data,
  })
}
export default {
  checkin,
  login,
  changeCheckcodeImg,
  changesignin,
  getPermissions,
  logout,
  getDomainUsers,
  convert,
  weather,
  CityinverseAnalysis,
  videoList,
  videoUrl,
  MonitoringControl,
  pictureupload,
  getWeather,
}
